
export function UpperCaseFormats(index, value) {
    let result = `${value.charAt(index).toUpperCase() + value.slice(1)}`
    return result;
}